import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Card, Breadcrumb, Row, Icon, Tabs, Checkbox } from 'antd';
import AdminProtected from '../common/AdminProtected';
import AllHomesTab from './AllHomesTab';
import AllUsersTab from './AllUsersTab';
// Others
import { strings } from '../../localization';
import { ROUTE_NAMES } from '../../utils';

import {
    isRoleAdministrator
} from '../../data/auth/selectors';

import {
    getShowDeletedRecords
} from '../../data/app/selector';

import {
    onShowDeletedRecords
} from '../../data/app/actions';

const { TabPane } = Tabs;

const Administration = ({isAdmin, showDeleted, onShowDeletedRecords}) => (
    <AdminProtected>
        <Layout key="administration-content">
            <Layout.Content style={{ padding: '10px' }}>
                <Card style={{ marginBottom: '30px' }}>
                    <h2 data-testid="headline">{strings.administration.route}</h2>
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={ROUTE_NAMES.ADMINISTRATION}>
                                <Icon type="deployment-unit" />
                                &nbsp;
                                {strings.administration.route}
                            </Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    {
                        isAdmin && <br />
                    }
                    {
                        isAdmin && <Checkbox
                            checked={showDeleted}
                            onChange={e => {onShowDeletedRecords(e.target.checked); setTimeout(() => window.location.reload(false), 1000)}}
                        >Deleted records</Checkbox>
                    }
                </Card>
                <Row>
                    <Row>
                        <Tabs
                            defaultActiveKey="0"
                            size="large"
                            tabBarGutter={30}
                            tabBarStyle={{ marginBottom: 0 }}
                        >
                            <TabPane
                                key="0"
                                tab={
                                    <span>
                                        <Icon type="home" />
                                        {strings.administration.allHomesLabel}
                                    </span>
                                }
                            >
                                <AllHomesTab msgs={strings} />
                            </TabPane>
                            <TabPane
                                key="1"
                                tab={
                                    <span>
                                        <Icon type="user" />
                                        {strings.administration.allUsersLabel}
                                    </span>
                                }
                            >
                                <AllUsersTab msgs={strings} />
                            </TabPane>
                        </Tabs>
                    </Row>
                </Row>
            </Layout.Content>
        </Layout>
    </AdminProtected>
);

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isAdmin: isRoleAdministrator(state),
        showDeleted: getShowDeletedRecords(state)
    }),
    {
        onShowDeletedRecords
    }
)(Administration);